<template>
  <div>
    <div class="gl_title_bar marginBottom10">
      <div class="gl_tb_left">
        <span class="normaltitle">{{storeName}}培训管理平台</span>
      </div>
    </div>
    <div class="toptitle">
      项目管理
    </div>
    <div class="form">
      <el-form :model="ruleForm"
               :rules="rules"
               ref="ruleForm"
               label-width="93px"
               label-position="right"
               class="demo-ruleForm">
        <div class="formBox">
          <div class="formLeft">
            <el-form-item label="项目名称："
                          prop="name">
              <el-input v-model="ruleForm.name"
                        placeholder="请输入项目名称"
                        style="width: 329px;"></el-input>
            </el-form-item>
            <el-form-item label="学习日期："
                          prop="startDate">
              <el-date-picker v-model="ruleForm.startDate"
                              type="date"
                              style="width:156px"
                              value-format="yyyy-MM-dd"
                              placeholder="选择开始日期">
              </el-date-picker>
              <div class="timecen"></div>
              <el-date-picker v-model="ruleForm.endDate"
                              type="date"
                              style="width:156px"
                              value-format="yyyy-MM-dd"
                              placeholder="选择结束日期">
              </el-date-picker>
            </el-form-item>
            <div class="chooseCourse"
                 @click="toCourse()">
              <img v-show="chooseCourse=='选择课程'"
                   src="../../assets/img/icon/jia.png"
                   alt="">
              <span>{{chooseCourse}}</span>
            </div>
          </div>
          <div>
            <el-form-item label="是否为学分项目："
                          label-width="135px"
                          prop="type">
              <el-select v-model="ruleForm.type"
                         style="width: 329px;"
                         placeholder="请选择是否为学分项目">
                <el-option label="是"
                           value="1"></el-option>
                <el-option label="否"
                           value="2"></el-option>
              </el-select>
            </el-form-item>
            <!-- <div class="chooseCourse"
                 v-show="ruleForm.type==2||ruleForm.type==''"
                 style="margin-left:135px"
                 @click="toCourse()">
              <img src="../../assets/img/icon/jia.png"
                   v-show="chooseCourse=='选择课程'"
                   alt="">
              <span>{{chooseCourse}}</span>
            </div> -->
            <el-form-item label="学分项目内容："
                          v-show="ruleForm.type==1"
                          label-width="135px">
              <el-input type="textarea"
                        class="textarea"
                        style="width: 329px;font-size:14px"
                        placeholder="请输入学分相关信息及获得方式，会以站内信的形式推送给本项目学员"
                        v-model="ruleForm.creditContent"></el-input>
            </el-form-item>
          </div>
        </div>
        <el-form-item>
          <div class="xzbtn"
               style="margin-left:280px"
               @click="submitForm">立即创建</div>
        </el-form-item>
      </el-form>
    </div>
    <el-dialog title="课程资源选择"
               :visible.sync="isCourseDetails"
               class="Courselist"
               width="856px">
      <div class="cltop">
        <el-input placeholder="请输入课程名称"
                  prefix-icon="el-icon-search"
                  class="cltinput"
                  v-model="clinput">
          <el-button style="background: #0B8586;"
                     slot="append"
                     @click="getCourseList">搜索</el-button>
        </el-input>
        <div class="cltbtn"
             @click="toAddCourse">确定</div>
      </div>
      <el-table :data="gridData"
                :row-key="getRowKey"
                border
                @selection-change="handleSelectionChange">
        <el-table-column type="selection"
                         :selectable="getselectable"
                         :reserve-selection="true"
                         width="55">
        </el-table-column>
        <el-table-column property="courseId"
                         label="课程ID"
                         width="100"></el-table-column>
        <el-table-column property="courseNmae"
                         label="课程名称"></el-table-column>
        <el-table-column property="createDate"
                         label="上传时间"
                         width="180"></el-table-column>
      </el-table>
      <div class="fenye">
        <pagination :total="pageCount2"
                    :limit="pageSize2"
                    :page="pageIndex2"
                    @page-change="pageChange2"></pagination>
      </div>

      <div class="tablesum">共 <span style="color:#0B8586">{{pageCount2}}</span> 条</div>
    </el-dialog>
  </div>
</template>

<script>
import Pagination from '../components/page/pagination.vue';
export default {
  name: 'project',
  components: {
    Pagination,
  },
  data () {
    return {
      storeName: '',
      ruleForm: {
        name: '',
        type: '2',
        creditContent: '',
        startDate: '',
        endDate: ''
      },
      courseIdStr: '',
      rules: {
        name: [
          { required: true, message: '请输入项目名称', trigger: 'blur' }
        ],
        startDate: [
          { required: true, message: '请选择时间日期', trigger: 'blur' }
        ],
        type: [
          { required: true, message: '请选择是否为学分项目', trigger: 'change' }
        ]
      },
      isCourseDetails: false,
      gridData: [],
      clinput: '',
      pageCount2: 0,
      pageIndex2: 1,
      pageSize2: 8,
      chooseCourse: '选择课程'
    };
  },
  created () {
    this.storeName = localStorage.getItem('storeName')
  },
  methods: {
    submitForm () {
      if (this.ruleForm.name == '') {
        this.$message.warning('项目名称不能为空');
        return
      } else if (this.ruleForm.type == '') {
        this.$message.warning('请选择是否为学分项目');
        return
      } else if (this.ruleForm.startDate == '' || this.ruleForm.endDate == '') {
        this.$message.warning('学习开始和结束时间均不能为空');
        return
      } else if (this.courseIdStr == '') {
        this.$message.warning('请选择课程');
        return
      }
      this.httphelper.post('/api/EnterProjectApi/SaveOrgProject', {
        userId: Number(JSON.parse(localStorage.getItem('ResData')).id),
        id: 0,
        orgId: Number(localStorage.getItem('storeId')),
        orgName: this.ruleForm.name,
        isCredit: this.ruleForm.type == 1 ? true : false,
        startDate: this.ruleForm.startDate,
        endDate: this.ruleForm.endDate,
        creditContent: this.ruleForm.creditContent,
        courIds: this.courseIdStr
      })
        .then(res => {
          if (res.data.code == 200) {
            this.$message.success('新建项目成功');
            this.$router.push({
              name: 'usProject'
            })
          } else {
            this.$message.error('新建课程失败');
          }
        });
    },
    toCourse () {
      this.clinput = ''
      this.getCourseList()
      this.isCourseDetails = true
    },
    getCourseList () {
      this.httphelper.post('/api/EnterProjectApi/GetOrgCoursePageList', {
        orgId: Number(localStorage.getItem('storeId')),
        courseName: this.clinput,
        proId: 0,
        page: this.pageIndex2,
        limit: this.pageSize2
      })
        .then(res => {
          if (res.data.code == 200) {
            this.pageCount2 = res.data.totalcount
            this.gridData = res.data.data
          }
        });
    },
    pageChange2 (page) {
      if (page == this.pageIndex2) {
        return;
      }
      this.pageIndex2 = page;
      this.getCourseList()
    },
    handleSelectionChange (val) {
      this.courseIdStr = ''
      for (let i = 0; i < val.length; i++) {
        if (this.courseIdStr == '') this.courseIdStr = val[i].courseId.toString()
        else this.courseIdStr += ',' + val[i].courseId
      }
    },
    getselectable (row) {
      return !row.isExist;
    },
    getRowKey (row) {
      return row.id
    },
    toAddCourse () {
      if (this.courseIdStr == '') return this.$message.error('请勾选课程后点击确定');
      this.isCourseDetails = false
      this.chooseCourse = '已完成课程选择'
    }
  }
};
</script>

<style scoped>
.toptitle {
    width: 100%;
    box-sizing: border-box;
    height: 57px;
    background: #f6f7fb;
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #0b8586;
    line-height: 56px;
    padding-left: 17px;
    margin: 30px 0 40px 0;
}
.formBox {
    display: flex;
    justify-content: space-between;
}
.chooseCourse {
    width: 327px;
    height: 38px;
    border: 1px solid #0b8586;
    border-radius: 4px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #0b8586;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: 93px;
    cursor: pointer;
}
.chooseCourse img {
    width: 21px;
    height: 21px;
    margin-right: 10px;
}
.timecen {
    width: 9px;
    display: inline-block;
    height: 1px;
    background-color: #000000;
    margin: 0px 4px 5px 4px;
}
.xzbtn {
    margin-top: 60px;
    margin-left: 375px;
    width: 200px;
    height: 36px;
    background: #0b8586;
    border-radius: 18px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    line-height: 36px;
    text-align: center;
    cursor: pointer;
}
.Courselist ::v-deep .el-dialog {
    padding: 50px 59px;
    height: 640px;
}
.Courselist ::v-deep .el-dialog__title {
    font-size: 26px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #000000;
}
.Courselist ::v-deep .el-dialog__header {
    padding: 0;
}
.Courselist ::v-deep .el-dialog__body {
    padding: 0;
}
.Courselist ::v-deep .cell {
    text-align: center;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.Courselist ::v-deep td,
.Courselist ::v-deep th {
    padding: 8px 0 !important;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000000;
}
.Courselist ::v-deep th {
    background: #edfafa;
}
.cltop {
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.cltbtn {
    width: 97px;
    height: 40px;
    background: #c32424;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #fffefe;
    line-height: 40px;
    text-align: center;
    border-radius: 4px;
    margin-left: 10px;
}
.cltinput {
    width: 610px;
}
.cltinput ::v-deep .el-input__inner {
    border-color: #0b8586;
}
.cltinput ::v-deep .el-input-group__append,
.cltinput ::v-deep.el-button {
    background-color: #0b8586;
    color: #fffefe;
    border-color: #0b8586;
}
.cltinput ::v-deep.el-button {
    width: 97px;
    font-family: Microsoft YaHei;
}
.pagination_Wrap {
    margin: 0;
    margin-top: 35px;
}
.textarea ::v-deep .el-textarea__inner {
    height: 77px;
    font-family: Microsoft YaHei !important;
}
.tablesum {
    width: 80px;
    position: absolute;
    bottom: 45px;
    right: 59px;
    text-align: right;
}
.fenye {
    width: 100%;
    position: absolute;
    left: 0px;
    bottom: 35px;
}
</style>